/** 表示整形（UI/UX設計書 §13：Intl / Asia-Tokyo） */
const jpy = new Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY" });
const dateTime = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo", year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit",
});
const dateOnly = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo", year: "numeric", month: "2-digit", day: "2-digit",
});

export const yen = (v: number) => jpy.format(v);
export const fmtDateTime = (iso: string) => dateTime.format(new Date(iso));
export const fmtDate = (iso: string) => dateOnly.format(new Date(iso));

export const ORDER_STATUS_LABEL: Record<string, string> = {
  pending: "支払い待ち",
  confirmed: "注文確定",
  shipped: "配送中",
  completed: "配達済",
  cancelled: "キャンセル",
  refund_requested: "返金申請中",
  refunded: "返金済",
};

export const ORDER_STATUS_TONE: Record<string, string> = {
  pending: "warning", confirmed: "primary", shipped: "primary",
  completed: "success", cancelled: "muted", refund_requested: "warning", refunded: "muted",
};
